<template>
  <main class="demo-login"><form @submit.prevent="login">
    <h1>ADMIN · PARTNER</h1><p>포트폴리오 파트너 체험</p>
    <label>아이디<input aria-label="아이디" value="admin" readonly /></label>
    <label>비밀번호<input aria-label="비밀번호" type="password" v-model="password" autocomplete="off" /></label>
    <p>테스트 비밀번호: 1234</p><p v-if="error" role="alert">{{ error }}</p>
    <button type="submit">LOGIN</button><p>가상 데이터만 사용하며 운영 서버에 연결하지 않습니다.</p>
  </form></main>
</template>
<script>
import client from '@/libs/http-client'
import { setAuthData } from '@/libs/auth-helper'
import { restoreDemo } from './session'
export default {
  data: () => ({ password: '', error: '' }),
  methods: {
    async login () {
      const { data } = await client.post('/api/member/login', { memId: 'admin', memPw: this.password })
      if (data.resultCode !== '0') { this.error = data.resultMessage; return }
      setAuthData(data.data)
      restoreDemo()
      this.$router.replace('/partnerMain')
    }
  }
}
</script>
<style scoped>
.demo-login { min-height:100vh; display:grid; place-items:center; background:#f1f4f9; color:#263349; }
form { width:380px; max-width:90vw; padding:32px; background:white; border:1px solid #d6deeb; border-radius:12px; }
h1 { font-size:25px; } p { margin:18px 0; line-height:1.5; } label { display:block; margin-top:20px; }
input { display:block; width:100%; padding:12px; box-sizing:border-box; border:1px solid #b9c6dc; margin-top:8px; }
button { width:100%; padding:14px; background:#5068d4; color:white; border:0; border-radius:5px; cursor:pointer; }
</style>
